import { ClientConfigProductName } from '@frontend/vanilla/core';

import { clientConfigAppGuard, productUnderMaintenanceGuard } from '../guards';
import { RoutesConfig } from './routes-config';

const routes: RoutesConfig = {
    routes: [
        {
            path: 'mokabingo',
            // eslint-disable-next-line @nx/enforce-module-boundaries
            loadChildren: () => import('../../../mokabingo-app/src/mokabingo.routes').then((t) => t.MOKABINGO_ROUTES),
            canActivate: [clientConfigAppGuard, productUnderMaintenanceGuard],
            data: { product: ClientConfigProductName.MOKABINGO },
        },
    ],
};

export default routes;
